import { useEffect, useRef, startTransition } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toRouterPath } from "../utils/appPaths";

/**
 * On hard reload, sync React Router with the browser URL (Shopify may include /calendar prefix).
 */
export default function RouteSync() {
  const location = useLocation();
  const navigate = useNavigate();
  const syncedRef = useRef(false);

  useEffect(() => {
    if (syncedRef.current) return;
    const browserPath = toRouterPath(window.location.pathname);
    const routerPath = location.pathname || "/";
    const search = window.location.search || location.search || "";
    if (browserPath !== routerPath) {
      navigate({ pathname: browserPath, search }, { replace: true });
    }
    syncedRef.current = true;
  }, [location.pathname, location.search, navigate]);

  useEffect(() => {
    const onPopState = () => {
      const browserPath = toRouterPath(window.location.pathname);
      const search = window.location.search || "";
      if (browserPath !== location.pathname) {
        startTransition(() => {
          navigate({ pathname: browserPath, search }, { replace: true });
        });
      }
    };
    window.addEventListener("popstate", onPopState);
    return () => window.removeEventListener("popstate", onPopState);
  }, [location.pathname, navigate]);

  return null;
}
